/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  UUID: any;
  Upload: any;
};

export type AwsS3File = {
  __typename?: 'AwsS3File';
  awsS3FileId: Scalars['ID'];
  objectUrl: Scalars['String'];
  originalName: Scalars['String'];
  presignedUrl: Scalars['String'];
};

export type CxProjectConnection = {
  __typename?: 'CXProjectConnection';
  nodes: Array<Project>;
  pageInfo: PageInfo;
};

export type CxSearchProjectInput = {
  /** 会社名 */
  companyName?: InputMaybe<Scalars['String']>;
  /** 案件ID */
  documentUniqueID?: InputMaybe<Scalars['String']>;
  /** お気に入りしているかどうか */
  favorite?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  /** 案件の進捗状況 */
  offset: Scalars['Int'];
  /**
   * 案件担当者
   * CXUserのUserIDを指定
   */
  representativeId?: InputMaybe<Scalars['ID']>;
  /** 依頼日(YYYY-MM-DD形式) */
  requestDate?: InputMaybe<Scalars['String']>;
  /** プロジェクトステータス */
  status?: InputMaybe<ProjectStatus>;
  /** 案件名 */
  title?: InputMaybe<Scalars['String']>;
};

/** コンテナのサイズに関する指定 */
export type CxSearchShipContainerSizeQuery = {
  /** 40HQのサイズのコンテナの数 */
  forty?: InputMaybe<Scalars['Int']>;
  /** 20DRのサイズのコンテナの数 */
  twenty?: InputMaybe<Scalars['Int']>;
};

/** 到着予定日の範囲に関する指定 */
export type CxSearchShipDateRangeQuery = {
  /** 範囲の終了日 */
  end?: InputMaybe<Scalars['String']>;
  /** 範囲の開始日 */
  start?: InputMaybe<Scalars['String']>;
  /** 日付に関するの条件 */
  type: CxSearchShipsRangeType;
};

export type CxSearchShipInput = {
  dateRange?: InputMaybe<CxSearchShipDateRangeQuery>;
  first: Scalars['Int'];
  location?: InputMaybe<CxSearchShipLocationQuery>;
  offset: Scalars['Int'];
  orderBy?: InputMaybe<CxSearchShipsOrder>;
  size?: InputMaybe<CxSearchShipContainerSizeQuery>;
  /** 積替え回数の指定 */
  transhipCountType?: InputMaybe<CxSearchTransshipCountType>;
};

/** pod/polに関する指定 */
export type CxSearchShipLocationQuery = {
  /** pod(mainPort)のID */
  podIDs?: InputMaybe<Array<Scalars['Int']>>;
  /** pol(mainPort)のID */
  polIDs?: InputMaybe<Array<Scalars['Int']>>;
};

export type CxSearchShipsOrder = {
  direction: CxSearchShipsOrderDirection;
  field: CxSearchShipsOrderField;
};

export enum CxSearchShipsOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum CxSearchShipsOrderField {
  /** 合計金額 */
  Amount = 'amount',
  /** カット日 */
  CutDay = 'cutDay',
  /** 合計日数 */
  Days = 'days',
  /** 到着日 */
  Eta = 'eta',
  /** 出発日 */
  Etd = 'etd'
}

export enum CxSearchShipsRangeType {
  /** カット日 */
  CutDay = 'cutDay',
  /** 出港日 */
  Eta = 'eta',
  /** 到着日 */
  Etd = 'etd'
}

export enum CxSearchTransshipCountType {
  /** すべて */
  All = 'all',
  /** 積替えあり(1以上) */
  Exist = 'exist',
  /** 積替えなし */
  None = 'none'
}

export type CalculateEstimateItemsAmountDetailItem = {
  childItemId: Scalars['Int'];
  count: Scalars['Float'];
  currentFeeId: Scalars['Int'];
  taxRateId: Scalars['Int'];
  unitFee: Scalars['Float'];
};

export type CalculateEstimateItemsAmountInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  items: Array<CalculateEstimateItemsAmountDetailItem>;
  /** 計算で使用するUSDレート。指定されない場合はデフォルトのレートが使われる */
  usdRate?: InputMaybe<Scalars['Float']>;
};

export type CalculateEstimateItemsAmountPayload = {
  __typename?: 'CalculateEstimateItemsAmountPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Giho手数料 */
  gihoFee: Scalars['Int'];
  /** 課税対象外物流費 */
  taxExemptSubtotal: Scalars['Int'];
  /** 免税物流費 */
  taxNonTaxableSubTotal: Scalars['Int'];
  /** 課税物流費 */
  taxableSubtotal: Scalars['Int'];
  /** 合計金額 */
  totalAmount: Scalars['Int'];
  /** 計算時点のUSDレート */
  usdRate: Scalars['Float'];
};

export type Company = {
  __typename?: 'Company';
  addressKana?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyClass?: Maybe<CompanyClass>;
  companyCode?: Maybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  /** @deprecated move to companyClass */
  companyKind?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nameKana?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Prefecture>;
  /** @deprecated move to prefecture */
  prefectureId?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
  users: Array<User>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CompanyClass = {
  __typename?: 'CompanyClass';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyHandle = {
  __typename?: 'CompanyHandle';
  handleNameEn: Scalars['String'];
  handleNameJP: Scalars['String'];
  id: Scalars['Int'];
};

export type ContactRoom = {
  __typename?: 'ContactRoom';
  id: Scalars['ID'];
  /** 親のプロジェクト */
  project: Project;
  /** 公開されている親のプロジェクト */
  publicProject: Project;
  /** 公開されているタイムライン */
  publicTimelines: Array<ContactRoomTimeline>;
  /** 非公開/公開されているタイムラインを含む全てのタイムライン */
  timelines: Array<ContactRoomTimeline>;
};

export type ContactRoomTimeline = {
  __typename?: 'ContactRoomTimeline';
  /**
   * 今後削除予定
   * @deprecated Use publicUser
   */
  author: User;
  contactRoom: ContactRoom;
  /** 今後削除予定 */
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  files: Array<AwsS3File>;
  id: Scalars['ID'];
  messages: Array<ContactRoomTimelineMessage>;
  publicContactRoom: ContactRoom;
  publicFiles?: Maybe<Array<AwsS3File>>;
  publicMessages: Array<ContactRoomTimelineMessage>;
  publicUser: User;
  title: Scalars['String'];
  /** 今後削除予定 */
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type ContactRoomTimelineMessage = {
  __typename?: 'ContactRoomTimelineMessage';
  files: Array<AwsS3File>;
  id: Scalars['ID'];
  message: Scalars['String'];
  publicFiles?: Maybe<Array<AwsS3File>>;
  /**  公開されている親のタイムライン  */
  publicTimeline?: Maybe<ContactRoomTimeline>;
  publicUser: User;
  sentAt: Scalars['DateTime'];
  /**  公開/非公開を含むタイムライン  */
  timeline?: Maybe<ContactRoomTimeline>;
  user: User;
};

export type CreateCompanyInput = {
  addressKana: Scalars['String'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyClassId: Scalars['Int'];
  companyCode: Scalars['Int'];
  name: Scalars['String'];
  nameKana: Scalars['String'];
  phoneNumber: Scalars['String'];
  prefectureId: Scalars['Int'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CreateCompanyPayload = {
  __typename?: 'CreateCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  company: Company;
};

export type CreateContactRoomInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
};

export type CreateContactRoomPayload = {
  __typename?: 'CreateContactRoomPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contactRoom?: Maybe<ContactRoom>;
};

export type CreateContactRoomTimelineInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactRoomId: Scalars['String'];
  description: Scalars['String'];
  files: Array<Scalars['Upload']>;
  title: Scalars['String'];
};

export type CreateContactRoomTimelineMessageInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['Upload']>;
  message: Scalars['String'];
  timelineId: Scalars['String'];
};

export type CreateContactRoomTimelineMessagePayload = {
  __typename?: 'CreateContactRoomTimelineMessagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message: ContactRoomTimelineMessage;
};

export type CreateContactRoomTimelinePayload = {
  __typename?: 'CreateContactRoomTimelinePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  timeline: ContactRoomTimeline;
};

export type CreateContainerEcEstimatePayload = {
  __typename?: 'CreateContainerECEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimate: WillboxEstimate;
};

export type CreateContainerEcEstimateRequestInput = {
  /** 依頼詳細に追記したい文言 */
  additionalDescription?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  shipId: Scalars['Int'];
  size: SearchShipContainerSizeQuery;
  /** TODO: フロント側実装が完了したらrequiredにする */
  title?: InputMaybe<Scalars['String']>;
};

export type CreateCxUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  cxUserCode: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateCxUserPayload = {
  __typename?: 'CreateCxUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  cxUser: CxUser;
};

export type CreateEstimateRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  files: Array<Scalars['Upload']>;
  incoterms?: InputMaybe<Incoterms>;
  podId?: InputMaybe<Scalars['Int']>;
  polId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateEstimateRequestPayload = {
  __typename?: 'CreateEstimateRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimateRequest: EstimateRequest;
};

export type CreateProjectProcessInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 公開 */
  isPublish: Scalars['Boolean'];
  /** 期限日 */
  limitedOn: Scalars['String'];
  projectId: Scalars['ID'];
  projectProcessTaskId: Scalars['Int'];
};

export type CreateProjectProcessPayload = {
  __typename?: 'CreateProjectProcessPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  projectProcess: ProjectProcess;
};

export type CreateProjectProcessesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 出港希望日 */
  desiredDepartureOn: Scalars['String'];
  projectId: Scalars['ID'];
  projectProcessPatternId: Scalars['Int'];
};

export type CreateProjectProcessesPayload = {
  __typename?: 'CreateProjectProcessesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  projectProcesses: Array<ProjectProcess>;
};

export type CreateProxyEstimateRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  files: Array<Scalars['Upload']>;
  incoterms?: InputMaybe<Incoterms>;
  /**
   * 出港希望日
   * 工程パターンIDと同時に指定された場合のみ工程パターンが作成される
   */
  limitedAt?: InputMaybe<Scalars['String']>;
  podId?: InputMaybe<Scalars['Int']>;
  polId?: InputMaybe<Scalars['Int']>;
  /**
   * 工程パターンID
   * 出向希望日と同時に指定された場合のみ工程パターンが作成される
   */
  projectProcessPatternId?: InputMaybe<Scalars['Int']>;
  /**
   * 案件担当者
   * CXUserのUserIDを指定
   */
  representativeId?: InputMaybe<Scalars['ID']>;
  shipperId: Scalars['String'];
  status: ProjectStatus;
  title: Scalars['String'];
};

export type CreateProxyEstimateRequestPayload = {
  __typename?: 'CreateProxyEstimateRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimateRequest: EstimateRequest;
};

export type CreateSupplierEmployeeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  nameKana?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  supplierId: Scalars['ID'];
};

export type CreateSupplierEmployeePayload = {
  __typename?: 'CreateSupplierEmployeePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  supplierEmployee: SupplierEmployee;
};

export type CreateSupplierInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyClass: Scalars['Int'];
  companyHandles: Array<Scalars['Int']>;
  companyLocationCity: Scalars['String'];
  companyLocationKana?: InputMaybe<Scalars['String']>;
  companyLocationPrefectureId: Scalars['Int'];
  companyLocationStreet: Scalars['String'];
  companyLocationZip: Scalars['String'];
  companyName: Scalars['String'];
  companyNameKana?: InputMaybe<Scalars['String']>;
  companyPhone: Scalars['String'];
};

export type CreateSupplierPayload = {
  __typename?: 'CreateSupplierPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  supplier: Supplier;
};

export type CreateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type CreateWillboxEstimateInput = {
  /** 備考 */
  caution: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 見積詳細 */
  createWillboxEstimateItems: Array<CreateWillboxEstimateInputRow>;
  /** 見積有効期限 */
  expiredOn: Scalars['Date'];
  /** ファイル */
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  incoterms?: InputMaybe<Scalars['String']>;
  /** 公開 */
  isPublish: Scalars['Boolean'];
  /** 支払い条件 */
  paymentTerms: Scalars['String'];
  /** 到着港 */
  podId?: InputMaybe<Scalars['Int']>;
  /** 出港港 */
  polId?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
  /** USD */
  usdRate: Scalars['Float'];
};

export type CreateWillboxEstimateInputRow = {
  /** 内訳 */
  childItemId: Scalars['Int'];
  /** 数量 */
  count: Scalars['Float'];
  /** 通貨 (USD, JPY) */
  currentFeeId: Scalars['Int'];
  /** 備考欄 */
  description: Scalars['String'];
  /** 海運業者（仕入れ先） */
  supplierId: Scalars['ID'];
  /** 税率 */
  taxRateId: Scalars['Int'];
  /** 合計 */
  totalFee: Scalars['Float'];
  /** 単価 */
  unitFee: Scalars['Float'];
  /** 単位 */
  unitId: Scalars['Int'];
};

export type CreateWillboxEstimatePayload = {
  __typename?: 'CreateWillboxEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  willboxEstimate: WillboxEstimate;
};

export enum CreateWillboxEstimateStatus {
  /** 成立 */
  IsDone = 'isDone',
  /** 不成立 */
  Rejected = 'rejected'
}

export type CreateWillboxEstimateStatusInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  status: CreateWillboxEstimateStatus;
  willboxEstimateId: Scalars['ID'];
};

export type CreateWillboxEstimateStatusPayload = {
  __typename?: 'CreateWillboxEstimateStatusPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  willboxEstimate: WillboxEstimate;
};

export type CxUser = {
  __typename?: 'CxUser';
  /** 荷主一覧 */
  companies: Array<Company>;
  /** 荷主詳細 */
  company: Company;
  companyClasses: Array<CompanyClass>;
  /** 業種 */
  companyHandles: Array<CompanyHandle>;
  contactRoomTimeline: ContactRoomTimeline;
  contactRoomTimelineMessages: Array<ContactRoomTimelineMessage>;
  /** CXユーザー */
  cxUsers: Array<CxUser>;
  /** 見積依頼詳細 */
  estimateRequest: EstimateRequest;
  /** 見積依頼一覧 */
  estimateRequests: Array<EstimateRequest>;
  id: Scalars['ID'];
  /** 特権管理者かどうか */
  isSuperUser: Scalars['Boolean'];
  /** 主要港 */
  mainPorts: Array<MainPort>;
  /** 都道府県 */
  prefectures?: Maybe<Array<Prefecture>>;
  /** 案件詳細 */
  project: Project;
  /** 工程管理のパターン */
  projectPrecessPatterns: Array<ProjectProcessPattern>;
  /** 工程管理のタスク */
  projectProcessTasks: Array<ProjectProcessTask>;
  /** 案件一覧 */
  projects: Array<Project>;
  /** 案件一覧V2 */
  projectsV2: CxProjectConnection;
  /** コンテナEC一覧の取得 */
  ships: ShipConnection;
  /** 業者詳細 */
  supplier: Supplier;
  /** 業者担当者一覧 */
  supplierEmployees: Array<SupplierEmployee>;
  /** 業者一覧 */
  suppliers: Array<Supplier>;
  /** USD/JPYのレート */
  usdRate: Scalars['Float'];
  /** CxUserに紐づくuser */
  user: User;
  /** 荷主ユーザ一覧 */
  users: Array<User>;
  willboxEstimate: WillboxEstimate;
  /** Currency */
  willboxEstimateCurrentFees: Array<WillboxEstimateCurrentFee>;
  willboxEstimateParentItems: Array<WillboxEstimateParentItem>;
  /** 税率 */
  willboxEstimateTaxRates: Array<WillboxEstimateTaxRate>;
  /** 単位 */
  willboxEstimateUnits: Array<WillboxEstimateUnit>;
  /** 見積一覧 */
  willboxEstimates: Array<WillboxEstimate>;
};


export type CxUserCompanyArgs = {
  companyId: Scalars['ID'];
};


export type CxUserContactRoomTimelineArgs = {
  timelineId: Scalars['UUID'];
};


export type CxUserContactRoomTimelineMessagesArgs = {
  timelineId: Scalars['UUID'];
};


export type CxUserEstimateRequestArgs = {
  estimateRequestId: Scalars['ID'];
};


export type CxUserProjectArgs = {
  projectId: Scalars['UUID'];
};


export type CxUserProjectsArgs = {
  status?: InputMaybe<ProjectStatus>;
};


export type CxUserProjectsV2Args = {
  input?: InputMaybe<CxSearchProjectInput>;
};


export type CxUserShipsArgs = {
  input: CxSearchShipInput;
};


export type CxUserSupplierArgs = {
  supplierId: Scalars['UUID'];
};


export type CxUserUsersArgs = {
  input?: InputMaybe<SearchUserInput>;
};


export type CxUserWillboxEstimateArgs = {
  willboxEstimateId: Scalars['UUID'];
};

export type DeleteCxUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type DeleteCxUserPayload = {
  __typename?: 'DeleteCxUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteEstimateRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  estimateRequestId: Scalars['ID'];
};

export type DeleteEstimateRequestPayload = {
  __typename?: 'DeleteEstimateRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteProjectProcessInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectProcessId: Scalars['ID'];
};

export type DeleteProjectProcessPayload = {
  __typename?: 'DeleteProjectProcessPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** 削除済の工程 */
  projectProcess: ProjectProcess;
};

export type DeleteSupplierEmployeeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  supplierEmployeeId: Scalars['ID'];
};

export type DeleteSupplierEmployeePayload = {
  __typename?: 'DeleteSupplierEmployeePayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteWillboxEstimateFileInput = {
  awsS3FileId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  willboxEstimateId: Scalars['ID'];
};

export type DeleteWillboxEstimateFilePayload = {
  __typename?: 'DeleteWillboxEstimateFilePayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type EstimateRequest = {
  __typename?: 'EstimateRequest';
  cargoDeliveryDate?: Maybe<Scalars['Date']>;
  /** 詳細 */
  description?: Maybe<Scalars['String']>;
  /** 「コンテナ情報」の出港希望日 */
  desiredDepartureDate?: Maybe<Scalars['DateTime']>;
  /** 全体のEstimateRequest UniqueID */
  documentUniqueId?: Maybe<Scalars['String']>;
  /** 添付ファイル */
  files: Array<AwsS3File>;
  id: Scalars['ID'];
  incoterms?: Maybe<Incoterms>;
  pickupDate?: Maybe<Scalars['Date']>;
  /** 引き取り日 */
  pickupOn?: Maybe<Scalars['Date']>;
  /** 荷物を下ろす場所 */
  pod?: Maybe<MainPort>;
  /** 輸送する貨物を積み込む場所 */
  pol?: Maybe<MainPort>;
  project: Project;
  /** 製品検査を希望するかどうか */
  requestCargoInspection?: Maybe<Scalars['Boolean']>;
  /** コンテナ収納検査を希望するかどうか */
  requestContainerLoadingInspection?: Maybe<Scalars['Boolean']>;
  /** 燻蒸証明書が必要かどうか */
  requestFumigationCertificate?: Maybe<Scalars['Boolean']>;
  /** 海上貨物保険が必要かどうか */
  requestMarineInsurance?: Maybe<Scalars['Boolean']>;
  /** 案件発生時期 */
  requestTimeOn?: Maybe<Scalars['Date']>;
  /** 出向先 */
  shippingLocation?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type EstimateRequestConnection = {
  __typename?: 'EstimateRequestConnection';
  nodes: Array<EstimateRequest>;
  pageInfo: PageInfo;
};

export type EstimateRequestsInput = {
  page?: Scalars['Int'];
};

export enum Incoterms {
  /** CFR	Cost and Freight (insert named port of destination)	運賃込み （指定仕向港を挿入） */
  Cfr = 'CFR',
  /** CIF	Cost Insurance and Freight (insert named port of destination)	運賃保険料込み （指定仕向港を挿入） */
  Cif = 'CIF',
  /** CIP	Carriage and Insurance Paid To (insert named place of destination)	輸送費保険料込み （指定仕向地を挿入） */
  Cip = 'CIP',
  /** CPT	Carriage Paid To (insert named place of destination)	輸送費込み （指定仕向地を挿入） */
  Cpt = 'CPT',
  /** DAP	Delivered at Place (insert named place of destination)	仕向地持込渡し （指定仕向地を挿入） */
  Dap = 'DAP',
  /** DDP	Delivered Duty Paid (insert named place of destination)	関税込持込渡し （指定仕向地を挿入） */
  Ddp = 'DDP',
  /** DPU	Delivered at Place Unloaded (insert named place of destination)	荷卸込持込渡し (指定仕向地を挿入) */
  Dpu = 'DPU',
  /** EXW	Ex Works (insert named place of delivery)	工場渡し（指定引渡地を挿入） */
  Exw = 'EXW',
  /** FAS	Free alongside Ship (insert named port of Shipment)	船側渡し （指定船積港を挿入） */
  Fas = 'FAS',
  /** FCA	Free Carrier (insert named place of delivery)r	運送人渡し（指定引渡地を挿入） */
  Fca = 'FCA',
  /** FOB	Free on Board (insert named port of shipment)	本船渡し（指定船積港を挿入） */
  Fob = 'FOB'
}

export type MainPort = {
  __typename?: 'MainPort';
  countryCode?: Maybe<Scalars['String']>;
  countryName: Scalars['String'];
  countryNameJa: Scalars['String'];
  id: Scalars['ID'];
  mainPort?: Maybe<Scalars['String']>;
  mainPortJa?: Maybe<Scalars['String']>;
  portCode?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  calculateEstimateItemsAmount: CalculateEstimateItemsAmountPayload;
  createCompany: CreateCompanyPayload;
  createContainerECEstimateRequest: CreateContainerEcEstimatePayload;
  createCxUser: CreateCxUserPayload;
  /** 案件管理の見積依頼作成 */
  createEstimateRequest: CreateEstimateRequestPayload;
  /** 案件管理の見積依頼作成 */
  createProjectProcess: CreateProjectProcessPayload;
  /** 案件管理の見積依頼作成 */
  createProjectProcesses: CreateProjectProcessesPayload;
  /** 案件管理の見積代理依頼作成 */
  createProxyEstimateRequest: CreateProxyEstimateRequestPayload;
  createSupplier: CreateSupplierPayload;
  createSupplierEmployee: CreateSupplierEmployeePayload;
  createUser: CreateUserPayload;
  createWillboxEstimate: CreateWillboxEstimatePayload;
  /** 成立、不成立へ状態を変更 */
  createWillboxEstimateStatus: CreateWillboxEstimateStatusPayload;
  cxCreateContactRoom: CreateContactRoomPayload;
  cxCreateContactRoomTimeline: CreateContactRoomTimelinePayload;
  cxCreateContactRoomTimelineMessage: CreateContactRoomTimelineMessagePayload;
  deleteCxUser: DeleteCxUserPayload;
  deleteEstimateRequest: DeleteEstimateRequestPayload;
  /** 工程の削除 */
  deleteProjectProcess: DeleteProjectProcessPayload;
  deleteSupplierEmployee: DeleteSupplierEmployeePayload;
  deleteWillboxEstimateFile: DeleteWillboxEstimateFilePayload;
  orderWillboxEstimate: OrderWillboxEstimatePayload;
  runConstraint: RunConstraintPayload;
  runConstraintFiles: RunConstraintFilesPayload;
  shipperCreateContactRoom: CreateContactRoomPayload;
  shipperCreateContactRoomTimeline: CreateContactRoomTimelinePayload;
  shipperCreateContactRoomTimelineMessage: CreateContactRoomTimelineMessagePayload;
  updateCXProjectFavorite: UpdateCxProjectFavoritePayload;
  updateCompany: UpdateCompanyPayload;
  updateContainerECData: UpdateContainerEcPayload;
  updateEstimateRequest: UpdateEstimateRequestPayload;
  updateProjectParticipants: UpdateProjectParticipantsPayload;
  /** 工程の編集 */
  updateProjectProcess: UpdateProjectProcessPayload;
  /** 担当者の更新 */
  updateProjectRepresentative: UpdateProjectRepresentativePayload;
  /** 案件のステータス変更 */
  updateProjectStatus: UpdateProjectStatusPayload;
  /** 案件のタイトル変更 */
  updateProjectTitle: UpdateProjectTitlePayload;
  updateShipperProjectFavorite: UpdateShipperProjectFavoritePayload;
  updateSupplier: UpdateSupplierPayload;
  updateSupplierEmployee: UpdateSupplierEmployeePayload;
  updateUser: UpdateUserPayload;
  updateWillboxEstimate: UpdateWillboxEstimatePayload;
  /** "見積の公開、非公開のみ変更を行うMutation */
  updateWillboxEstimateIsPublish: UpdateWillboxEstimateIsPublishPayload;
};


export type MutationCalculateEstimateItemsAmountArgs = {
  input: CalculateEstimateItemsAmountInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateContainerEcEstimateRequestArgs = {
  input: CreateContainerEcEstimateRequestInput;
};


export type MutationCreateCxUserArgs = {
  input: CreateCxUserInput;
};


export type MutationCreateEstimateRequestArgs = {
  input: CreateEstimateRequestInput;
};


export type MutationCreateProjectProcessArgs = {
  input: CreateProjectProcessInput;
};


export type MutationCreateProjectProcessesArgs = {
  input: CreateProjectProcessesInput;
};


export type MutationCreateProxyEstimateRequestArgs = {
  input: CreateProxyEstimateRequestInput;
};


export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput;
};


export type MutationCreateSupplierEmployeeArgs = {
  input: CreateSupplierEmployeeInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWillboxEstimateArgs = {
  input: CreateWillboxEstimateInput;
};


export type MutationCreateWillboxEstimateStatusArgs = {
  input: CreateWillboxEstimateStatusInput;
};


export type MutationCxCreateContactRoomArgs = {
  input: CreateContactRoomInput;
};


export type MutationCxCreateContactRoomTimelineArgs = {
  input: CreateContactRoomTimelineInput;
};


export type MutationCxCreateContactRoomTimelineMessageArgs = {
  input: CreateContactRoomTimelineMessageInput;
};


export type MutationDeleteCxUserArgs = {
  input: DeleteCxUserInput;
};


export type MutationDeleteEstimateRequestArgs = {
  input: DeleteEstimateRequestInput;
};


export type MutationDeleteProjectProcessArgs = {
  input: DeleteProjectProcessInput;
};


export type MutationDeleteSupplierEmployeeArgs = {
  input: DeleteSupplierEmployeeInput;
};


export type MutationDeleteWillboxEstimateFileArgs = {
  input: DeleteWillboxEstimateFileInput;
};


export type MutationOrderWillboxEstimateArgs = {
  input: OrderWillboxEstimateInput;
};


export type MutationRunConstraintArgs = {
  input: RunConstraintInput;
};


export type MutationRunConstraintFilesArgs = {
  input: RunConstraintFilesInput;
};


export type MutationShipperCreateContactRoomArgs = {
  input: CreateContactRoomInput;
};


export type MutationShipperCreateContactRoomTimelineArgs = {
  input: CreateContactRoomTimelineInput;
};


export type MutationShipperCreateContactRoomTimelineMessageArgs = {
  input: CreateContactRoomTimelineMessageInput;
};


export type MutationUpdateCxProjectFavoriteArgs = {
  input: UpdateCxProjectFavoriteInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateContainerEcDataArgs = {
  input: UpdateContainerEcInput;
};


export type MutationUpdateEstimateRequestArgs = {
  input: UpdateEstimateRequestInput;
};


export type MutationUpdateProjectParticipantsArgs = {
  input: UpdateProjectParticipantsInput;
};


export type MutationUpdateProjectProcessArgs = {
  input: UpdateProjectProcessInput;
};


export type MutationUpdateProjectRepresentativeArgs = {
  input: UpdateProjectRepresentativeInput;
};


export type MutationUpdateProjectStatusArgs = {
  input: UpdateProjectStatusInput;
};


export type MutationUpdateProjectTitleArgs = {
  input: UpdateProjectTitleInput;
};


export type MutationUpdateShipperProjectFavoriteArgs = {
  input: UpdateShipperProjectFavoriteInput;
};


export type MutationUpdateSupplierArgs = {
  input: UpdateSupplierInput;
};


export type MutationUpdateSupplierEmployeeArgs = {
  input: UpdateSupplierEmployeeInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWillboxEstimateArgs = {
  input: UpdateWillboxEstimateInput;
};


export type MutationUpdateWillboxEstimateIsPublishArgs = {
  input: UpdateWillboxEstimateIsPublishInput;
};

export type OrderWillboxEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  willboxEstimateId: Scalars['ID'];
};

export type OrderWillboxEstimatePayload = {
  __typename?: 'OrderWillboxEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  willboxEstimate: WillboxEstimate;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  page: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Prefecture = {
  __typename?: 'Prefecture';
  id: Scalars['ID'];
  nameEn: Scalars['String'];
  nameJp: Scalars['String'];
  nameKana: Scalars['String'];
};

export type Project = {
  __typename?: 'Project';
  company?: Maybe<Company>;
  contactRoom?: Maybe<ContactRoom>;
  createdAt: Scalars['DateTime'];
  cxFavorite: Scalars['Boolean'];
  /** CX向けのファイル一覧 */
  cxFiles: Array<ProjectFile>;
  /** "CXユーザーが取得するQuery */
  cxShipper: Shipper;
  estimateRequest: EstimateRequest;
  /** 案件内でアップロードされたファイルを全て返却（見積依頼、タイムライン作成、メッセージ作成） */
  files: Array<ProjectFile>;
  id: Scalars['ID'];
  /** "プロジェクトの関係者 */
  participants: Array<Shipper>;
  processes: Array<ProjectProcess>;
  /** 公開されている工程管理 */
  publicProcesses: Array<ProjectProcess>;
  /** 公開済の見積 */
  publicWillboxEstimates: Array<WillboxEstimate>;
  /** 担当者 */
  representative?: Maybe<CxUser>;
  shipper: Shipper;
  /** お気に入りしているかどうか */
  shipperFavorite: Scalars['Boolean'];
  status: ProjectStatus;
  title: Scalars['String'];
  /** 見積 */
  willboxEstimates: Array<WillboxEstimate>;
};

export enum ProjectAction {
  /** タイムラインの作成 */
  CreateContactRoomTimeline = 'createContactRoomTimeline',
  /** メッセージの作成 */
  CreateContactRoomTimelineMessage = 'createContactRoomTimelineMessage',
  /** 見積依頼作成 */
  CreateEstimateRequest = 'createEstimateRequest'
}

/** 案件内でアップロードされたファイル */
export type ProjectFile = {
  __typename?: 'ProjectFile';
  action: ProjectAction;
  contactRoomId?: Maybe<Scalars['ID']>;
  contactRoomTimelineId?: Maybe<Scalars['ID']>;
  file: AwsS3File;
  id: Scalars['ID'];
  /** リンクに使用する */
  projectId: Scalars['ID'];
  /** 送信日時 */
  sentAt: Scalars['DateTime'];
  user: User;
};

export type ProjectProcess = {
  __typename?: 'ProjectProcess';
  id: Scalars['ID'];
  isDone: Scalars['Boolean'];
  isPublish: Scalars['Boolean'];
  limitedOn: Scalars['Date'];
  task: ProjectProcessTask;
};

export type ProjectProcessPattern = {
  __typename?: 'ProjectProcessPattern';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProjectProcessTask = {
  __typename?: 'ProjectProcessTask';
  id: Scalars['ID'];
  nameEn: Scalars['String'];
  nameJp: Scalars['String'];
  taskPatterns: Array<ProjectProcessTaskPattern>;
};

export type ProjectProcessTaskPattern = {
  __typename?: 'ProjectProcessTaskPattern';
  deductionDays: Scalars['Int'];
  id: Scalars['ID'];
  pattern: ProjectProcessPattern;
  position: Scalars['Int'];
  task: ProjectProcessTask;
};

/** 参考 https://github.com/WillboxJp/giho-backend/blob/6512712b43f9d722dba411fbb84b6c86b365c099/packages/Ordering/Domain/Models/Project/ProjectStatusEnum.php */
export enum ProjectStatus {
  /** 完了 */
  Done = 'done',
  /** 注文中 */
  IsOrder = 'isOrder',
  /** 進行中 */
  Pending = 'pending',
  /** 失注 */
  Rejected = 'rejected',
  /** 発注前 */
  Request = 'request'
}

export type Query = {
  __typename?: 'Query';
  cxViewer: CxUser;
  shipperViewer: Shipper;
};

export enum Role {
  /** 社内管理社 */
  CxUser = 'CX_USER',
  /** 開発者 */
  DeveloperUser = 'DEVELOPER_USER',
  /** 物流会社（業者） */
  LogisticsUser = 'LOGISTICS_USER',
  /** 荷主 */
  ShipperUser = 'SHIPPER_USER'
}

export type RunConstraintFilesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['Upload']>;
};

export type RunConstraintFilesPayload = {
  __typename?: 'RunConstraintFilesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RunConstraintInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  formatEmail?: InputMaybe<Scalars['String']>;
  minmaxInt?: InputMaybe<Scalars['Int']>;
  minmaxStringLength?: InputMaybe<Scalars['String']>;
  patternString?: InputMaybe<Scalars['String']>;
};

export type RunConstraintPayload = {
  __typename?: 'RunConstraintPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

/** @see ProjectStatus */
export enum SearchProjectStatus {
  /** すべて */
  All = 'all',
  /** 完了 */
  Done = 'done',
  /** 注文中 */
  IsOrder = 'isOrder',
  /** 進行中 */
  Pending = 'pending',
  /** 失注 */
  Rejected = 'rejected',
  /** 発注前 */
  Request = 'request'
}

/** コンテナのサイズに関する指定 */
export type SearchShipContainerSizeQuery = {
  /** 40HQのサイズのコンテナの数 */
  forty: Scalars['Int'];
  /** 20DRのサイズのコンテナの数 */
  twenty: Scalars['Int'];
};

/** 到着予定日の範囲に関する指定 */
export type SearchShipDateRangeQuery = {
  /** 範囲の終了日 */
  end: Scalars['String'];
  /** 範囲の開始日 */
  start: Scalars['String'];
  type: SearchShipsRangeType;
};

export type SearchShipInput = {
  /** 日付に関するの条件 */
  dateRange: SearchShipDateRangeQuery;
  first: Scalars['Int'];
  location: SearchShipLocationQuery;
  offset: Scalars['Int'];
  orderBy?: InputMaybe<SearchShipsOrder>;
  size: SearchShipContainerSizeQuery;
  /** 積替え回数の指定 */
  transhipCountType: SearchTransshipCountType;
};

/** pod/polに関する指定 */
export type SearchShipLocationQuery = {
  /** pod(mainPort)のID */
  podIDs: Array<Scalars['Int']>;
  /** pol(mainPort)のID */
  polIDs: Array<Scalars['Int']>;
};

export type SearchShipsOrder = {
  direction?: InputMaybe<SearchShipsOrderDirection>;
  field?: InputMaybe<SearchShipsOrderField>;
};

export enum SearchShipsOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SearchShipsOrderField {
  /** 合計金額 */
  Amount = 'amount',
  /** カット日 */
  CutDay = 'cutDay',
  /** 合計日数 */
  Days = 'days',
  /** 出航日 */
  Eta = 'eta',
  /** 出発日 */
  Etd = 'etd'
}

export enum SearchShipsRangeType {
  /** カット日 */
  CutDay = 'cutDay',
  /** 出港日 */
  Eta = 'eta',
  /** 到着日 */
  Etd = 'etd'
}

export enum SearchTransshipCountType {
  /** すべて */
  All = 'all',
  /** 積替えあり(1以上) */
  Exist = 'exist',
  /** 積替えなし */
  None = 'none'
}

export type SearchUserInput = {
  /** 会社名 */
  companyName?: InputMaybe<Scalars['String']>;
  /** ユーザー名 */
  userName?: InputMaybe<Scalars['String']>;
};

export type Ship = {
  __typename?: 'Ship';
  /** カット日(コンテナヤードへの搬入最終日) */
  cutDay: Scalars['Date'];
  /** 合計日数 */
  days: Scalars['Int'];
  /** コンテナ料金明細 */
  detailItems: Array<ShipDetailItem>;
  /** 船会社料金合計 */
  detailItemsTotalAmount: Scalars['Int'];
  /** 到着予定日(Estimated Time of Arrival) */
  eta: Scalars['Date'];
  /** 出発予定日(Estimated Time of Departure) */
  etd: Scalars['Date'];
  /** willbox手数料 */
  fee: ShipWillboxFee;
  id: Scalars['ID'];
  obsolete: Scalars['Boolean'];
  /** 積地港(Port of Loading) */
  pod: MainPort;
  /** 卸地港(Port of Discharge) */
  pol: MainPort;
  /** スケジュールのみの登録なのかどうかを判定するフラグ */
  scheduleOnly: Scalars['Boolean'];
  supplier: Supplier;
  /** 「ドル合計金額×USD/JPY rate + 日本円の合計金額」を小数点以下切り捨て */
  totalAmount: Scalars['Int'];
  /** レートをJPYで保持しているdetail_itemの日本円建て合計金額(小数点以下切り捨て) */
  totalAmountJPY: Scalars['Int'];
  /** レートをUSDで保持しているdetail_itemのドル建て合計金額 */
  totalAmountUSD: Scalars['Float'];
  /** 積み替え港 */
  tranships: Array<ShipTranship>;
};

export type ShipConnection = {
  __typename?: 'ShipConnection';
  nodes: Array<Ship>;
  pageInfo: PageInfo;
};

export type ShipDetailItem = {
  __typename?: 'ShipDetailItem';
  /** 項目 */
  childItem: WillboxEstimateChildItem;
  /** 数量 */
  count: Scalars['Int'];
  /** 通貨 */
  currency: WillboxEstimateCurrentFee;
  id: Scalars['ID'];
  /** 免税/課税 */
  taxRate: WillboxEstimateTaxRate;
  /** USDの場合はその値×数量×rate、JPYの場合はその値×数量を小数点以下切り捨て */
  totalAmount: Scalars['Int'];
  /** itemがJPYのものであればその値×数量(小数点以下切り捨て)、USDの場合は0 */
  totalAmountJPY: Scalars['Int'];
  /** itemがUSDのものであればその値×数量、JPYの場合は0 */
  totalAmountUSD: Scalars['Float'];
  /** 単位 */
  unit: WillboxEstimateUnit;
  /** 単価 */
  unitPrice: Scalars['Float'];
};

export type ShipTranship = {
  __typename?: 'ShipTranship';
  eta: Scalars['Date'];
  etd: Scalars['Date'];
  id: Scalars['ID'];
  port: MainPort;
};

export type ShipWillboxFee = {
  __typename?: 'ShipWillboxFee';
  currency: Scalars['String'];
  name: Scalars['String'];
  /** 「日本円換算の合計金額」から算出した手数料を小数点以下切り捨て */
  totalAmount: Scalars['Int'];
  unitName: Scalars['String'];
};

export type Shipper = {
  __typename?: 'Shipper';
  company: ShipperCompany;
  contactRoomTimeline: ContactRoomTimeline;
  contactRoomTimelineMessages: Array<ContactRoomTimelineMessage>;
  email?: Maybe<Scalars['String']>;
  estimateRequest: EstimateRequest;
  /** Shipperに属するEstimateRequest */
  estimateRequests: EstimateRequestConnection;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  /** 主要港 */
  mainPorts: Array<MainPort>;
  project: Project;
  projects?: Maybe<Array<Project>>;
  /** 案件一覧V2 */
  projectsV2: ShipperProjectConnection;
  /** 公開済の見積 */
  publicWillboxEstimate: WillboxEstimate;
  /** コンテナECの検索 */
  ships: ShipConnection;
  /** USD/JPYのレート */
  usdRate: Scalars['Float'];
};


export type ShipperContactRoomTimelineArgs = {
  id: Scalars['UUID'];
};


export type ShipperContactRoomTimelineMessagesArgs = {
  id: Scalars['UUID'];
};


export type ShipperEstimateRequestArgs = {
  id: Scalars['UUID'];
};


export type ShipperEstimateRequestsArgs = {
  input?: InputMaybe<EstimateRequestsInput>;
};


export type ShipperProjectArgs = {
  id: Scalars['UUID'];
};


export type ShipperProjectsV2Args = {
  input?: InputMaybe<ShipperSearchProjectInput>;
};


export type ShipperPublicWillboxEstimateArgs = {
  willboxEstimateId: Scalars['UUID'];
};


export type ShipperShipsArgs = {
  input: SearchShipInput;
};

export type ShipperAccount = {
  __typename?: 'ShipperAccount';
  addressKana?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameKana?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  prefectureId?: Maybe<Scalars['Int']>;
  shipperAccountCode: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ShipperCompany = {
  __typename?: 'ShipperCompany';
  addressKana: Scalars['String'];
  city: Scalars['String'];
  companyCode: Scalars['Int'];
  companyKind: Scalars['Int'];
  /** Companyに属する見積依頼 */
  estimateRequests: Array<EstimateRequest>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameKana: Scalars['String'];
  phoneNumber: Scalars['String'];
  /** Companyに属する案件 */
  projects: Array<Project>;
  shippers: Array<Shipper>;
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type ShipperProjectConnection = {
  __typename?: 'ShipperProjectConnection';
  nodes: Array<Project>;
  pageInfo: PageInfo;
};

export type ShipperSearchProjectInput = {
  /** 案件ID */
  documentUniqueID?: InputMaybe<Scalars['String']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  /**
   * 案件担当者
   * CXUserのUserIDを指定
   */
  representativeId?: InputMaybe<Scalars['ID']>;
  /** 依頼日(YYYY-MM-DD形式) */
  requestDate?: InputMaybe<Scalars['String']>;
  /** プロジェクトステータス */
  status?: InputMaybe<ProjectStatus>;
  /** 案件名 */
  title?: InputMaybe<Scalars['String']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  city: Scalars['String'];
  companyClass: CompanyClass;
  companyHandles: Array<CompanyHandle>;
  companyLocationKana: Scalars['String'];
  companyName: Scalars['String'];
  companyNameKana: Scalars['String'];
  companyPhone: Scalars['String'];
  id: Scalars['ID'];
  prefecture: Prefecture;
  street: Scalars['String'];
  supplierEmployees: Array<SupplierEmployee>;
  zipCode: Scalars['String'];
};

export type SupplierEmployee = {
  __typename?: 'SupplierEmployee';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameKana: Scalars['String'];
  phone: Scalars['String'];
  supplier: Supplier;
};

export type UpdateCxProjectFavoriteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  favorite: Scalars['Boolean'];
  projectId: Scalars['ID'];
};

export type UpdateCxProjectFavoritePayload = {
  __typename?: 'UpdateCXProjectFavoritePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
};

export type UpdateCompanyInput = {
  addressKana: Scalars['String'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyCode: Scalars['Int'];
  companyKind: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameKana: Scalars['String'];
  phoneNumber: Scalars['String'];
  prefectureId: Scalars['Int'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type UpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
};

export type UpdateContainerEcInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**  104857600 = 1024 * 1024 * 100 = 100MB  */
  csv: Array<Scalars['Upload']>;
};

export type UpdateContainerEcPayload = {
  __typename?: 'UpdateContainerECPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateEstimateRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  incoterms?: InputMaybe<Incoterms>;
  podId?: InputMaybe<Scalars['Int']>;
  polId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type UpdateEstimateRequestPayload = {
  __typename?: 'UpdateEstimateRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimateRequest: EstimateRequest;
};

export type UpdateProjectParticipantsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  shipperIds: Array<Scalars['ID']>;
};

export type UpdateProjectParticipantsPayload = {
  __typename?: 'UpdateProjectParticipantsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  shippers: Array<Shipper>;
};

export type UpdateProjectProcessInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 公開 */
  isPublish: Scalars['Boolean'];
  /** 期限日 */
  limitedOn: Scalars['Date'];
  projectProcessId: Scalars['ID'];
};

export type UpdateProjectProcessPayload = {
  __typename?: 'UpdateProjectProcessPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  projectProcess: ProjectProcess;
};

export type UpdateProjectRepresentativeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  /**
   * 案件担当者
   * CXUserのUserIDを指定
   */
  representativeId: Scalars['ID'];
};

export type UpdateProjectRepresentativePayload = {
  __typename?: 'UpdateProjectRepresentativePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
};

export type UpdateProjectStatusInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  isPublish: Scalars['Boolean'];
  projectId: Scalars['ID'];
  status: ProjectStatus;
};

export type UpdateProjectStatusPayload = {
  __typename?: 'UpdateProjectStatusPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
};

export type UpdateProjectTitleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateProjectTitlePayload = {
  __typename?: 'UpdateProjectTitlePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
};

export type UpdateShipperProjectFavoriteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  favorite: Scalars['Boolean'];
  projectId: Scalars['ID'];
};

export type UpdateShipperProjectFavoritePayload = {
  __typename?: 'UpdateShipperProjectFavoritePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  project: Project;
};

export type UpdateSupplierEmployeeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  nameKana?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  supplierEmployeeId: Scalars['ID'];
  supplierId: Scalars['ID'];
};

export type UpdateSupplierEmployeePayload = {
  __typename?: 'UpdateSupplierEmployeePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  supplierEmployee: SupplierEmployee;
};

export type UpdateSupplierInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyClass: Scalars['Int'];
  companyHandles: Array<Scalars['Int']>;
  companyId: Scalars['ID'];
  companyLocationCity: Scalars['String'];
  companyLocationKana?: InputMaybe<Scalars['String']>;
  companyLocationPrefectureId: Scalars['Int'];
  companyLocationStreet: Scalars['String'];
  companyLocationZip: Scalars['String'];
  companyName: Scalars['String'];
  companyNameKana?: InputMaybe<Scalars['String']>;
  companyPhone: Scalars['String'];
};

export type UpdateSupplierPayload = {
  __typename?: 'UpdateSupplierPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  supplier: Supplier;
};

export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['ID'];
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type UpdateWillboxEstimateInput = {
  /** 備考 */
  caution: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 見積有効期限 */
  expiredOn: Scalars['Date'];
  /** ファイル */
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  incoterms?: InputMaybe<Scalars['String']>;
  /** 公開 */
  isPublish: Scalars['Boolean'];
  /** 支払い条件 */
  paymentTerms: Scalars['String'];
  /** 到着港 */
  podId?: InputMaybe<Scalars['Int']>;
  /** 出港港 */
  polId?: InputMaybe<Scalars['Int']>;
  /** 見積詳細 */
  updateWillboxEstimateItems: Array<UpdateWillboxEstimateInputItem>;
  /** USDレート */
  usdRate: Scalars['Float'];
  willboxEstimateId: Scalars['ID'];
};

export type UpdateWillboxEstimateInputItem = {
  /** 内訳 */
  childItemId: Scalars['Int'];
  /** 数量 */
  count: Scalars['Float'];
  /** 通貨 (USD, JPY) */
  currentFeeId: Scalars['Int'];
  /** 備考欄 */
  description: Scalars['String'];
  /** 海運業者（仕入れ先） */
  supplierId: Scalars['ID'];
  /** 税率 */
  taxRateId: Scalars['Int'];
  /** 合計 */
  totalFee: Scalars['Float'];
  /** 単価 */
  unitFee: Scalars['Float'];
  /** 単位 */
  unitId: Scalars['Int'];
};

export type UpdateWillboxEstimateIsPublishInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 公開 */
  isPublish: Scalars['Boolean'];
  willboxEstimateId: Scalars['ID'];
};

export type UpdateWillboxEstimateIsPublishPayload = {
  __typename?: 'UpdateWillboxEstimateIsPublishPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  willboxEstimate: WillboxEstimate;
};

export type UpdateWillboxEstimatePayload = {
  __typename?: 'UpdateWillboxEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  willboxEstimate: WillboxEstimate;
};

export type User = {
  __typename?: 'User';
  company?: Maybe<Company>;
  companyId: Scalars['ID'];
  email: Scalars['String'];
  /** フロント対応後、 @hasRole(role: CX_USER) を付与する */
  firstName: Scalars['String'];
  id: Scalars['ID'];
  /** フロント対応後、 @hasRole(role: CX_USER) を付与する */
  lastName: Scalars['String'];
  publicFirstName: Scalars['String'];
  publicLastName: Scalars['String'];
};

export type WillboxEstimate = {
  __typename?: 'WillboxEstimate';
  caution: Scalars['String'];
  createdAt: Scalars['DateTime'];
  files: Array<AwsS3File>;
  /** Giho手数料 */
  gihoFee: Scalars['Int'];
  id: Scalars['ID'];
  incoterms: Incoterms;
  /** 見積が有効期限切れかどうか */
  isExpired: Scalars['Boolean'];
  isOrder: Scalars['Boolean'];
  /** 公開 */
  isPublish: Scalars['Boolean'];
  /** 項目 */
  items: Array<WillboxEstimateItem>;
  /** 合計金額(円) */
  jpySubtotal: Scalars['Int'];
  /** 最新ステータス */
  latestStatus?: Maybe<WillboxEstimateLatestStatus>;
  limitedOn?: Maybe<Scalars['Date']>;
  /** 課税対象外合計 */
  nonTaxableSubtotal: Scalars['Int'];
  /** 見積番号 */
  number: Scalars['String'];
  /** 注文書 */
  orderFile?: Maybe<AwsS3File>;
  paymentTerms: Scalars['String'];
  pod?: Maybe<MainPort>;
  pol?: Maybe<MainPort>;
  project: Project;
  publicOrderFile?: Maybe<AwsS3File>;
  publicTransactionCertificateFile?: Maybe<AwsS3File>;
  publicWillboxEstimateFile?: Maybe<AwsS3File>;
  /** 免税合計 */
  taxExemptSubtotal: Scalars['Int'];
  /** 消費税額 */
  taxableSubtotal: Scalars['Int'];
  /** 合計金額 */
  totalAmount: Scalars['Int'];
  /** 取引成立書 */
  transactionCertificateFile?: Maybe<AwsS3File>;
  updatedAt: Scalars['DateTime'];
  /** USD */
  usdRate: Scalars['Float'];
  /** 合計金額(USD) */
  usdSubtotal: Scalars['Int'];
  /** 見積書 */
  willboxEstimateFile?: Maybe<AwsS3File>;
};

export type WillboxEstimateChildItem = {
  __typename?: 'WillboxEstimateChildItem';
  id: Scalars['Int'];
  name: Scalars['String'];
  parentItem: WillboxEstimateParentItem;
};

export type WillboxEstimateCurrentFee = {
  __typename?: 'WillboxEstimateCurrentFee';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type WillboxEstimateItem = {
  __typename?: 'WillboxEstimateItem';
  childItem: WillboxEstimateChildItem;
  count: Scalars['Float'];
  currencyFee: WillboxEstimateCurrentFee;
  description: Scalars['String'];
  id: Scalars['ID'];
  parentItem: WillboxEstimateParentItem;
  supplier: Supplier;
  taxRate: WillboxEstimateTaxRate;
  totalFee: Scalars['Float'];
  unit: WillboxEstimateUnit;
  unitFee: Scalars['Float'];
};

export enum WillboxEstimateLatestStatus {
  InProgress = 'inProgress',
  IsDone = 'isDone',
  Rejected = 'rejected'
}

export type WillboxEstimateParentItem = {
  __typename?: 'WillboxEstimateParentItem';
  childItems: Array<WillboxEstimateChildItem>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type WillboxEstimateTaxRate = {
  __typename?: 'WillboxEstimateTaxRate';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type WillboxEstimateUnit = {
  __typename?: 'WillboxEstimateUnit';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Header_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Header_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, company: { __typename?: 'ShipperCompany', id: string, name: string } } };

export type ContainerEc_QueryQueryVariables = Exact<{
  orderBy?: InputMaybe<SearchShipsOrder>;
  dateRange: SearchShipDateRangeQuery;
  location: SearchShipLocationQuery;
  size: SearchShipContainerSizeQuery;
  transhipCountType: SearchTransshipCountType;
  offset: Scalars['Int'];
  first: Scalars['Int'];
}>;


export type ContainerEc_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', usdRate: number, ships: { __typename?: 'ShipConnection', nodes: Array<{ __typename?: 'Ship', id: string, days: number, cutDay: any, etd: any, eta: any, totalAmount: number, totalAmountJPY: number, totalAmountUSD: number, detailItemsTotalAmount: number, supplier: { __typename?: 'Supplier', companyName: string, id: string, companyNameKana: string }, fee: { __typename?: 'ShipWillboxFee', name: string, currency: string, unitName: string, totalAmount: number }, detailItems: Array<{ __typename?: 'ShipDetailItem', id: string, unitPrice: number, count: number, totalAmountJPY: number, totalAmountUSD: number, totalAmount: number, taxRate: { __typename?: 'WillboxEstimateTaxRate', id: number, name: string }, unit: { __typename?: 'WillboxEstimateUnit', id: number, name: string }, childItem: { __typename?: 'WillboxEstimateChildItem', id: number, name: string }, currency: { __typename?: 'WillboxEstimateCurrentFee', id: number, name: string } }>, pol: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null }, pod: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null }, tranships: Array<{ __typename?: 'ShipTranship', id: string, etd: any, eta: any, port: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } }> }>, pageInfo: { __typename?: 'PageInfo', page: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type CreateContainerEcEstimateRequestMutationVariables = Exact<{
  input: CreateContainerEcEstimateRequestInput;
}>;


export type CreateContainerEcEstimateRequestMutation = { __typename?: 'Mutation', createContainerECEstimateRequest: { __typename: 'CreateContainerECEstimatePayload', estimate: { __typename: 'WillboxEstimate', id: string, project: { __typename?: 'Project', id: string } } } };

export type _NewEstimateRequest_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type _NewEstimateRequest_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, mainPorts: Array<{ __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null }>, projects?: Array<{ __typename?: 'Project', id: string, title: string, createdAt: any, status: ProjectStatus, company?: { __typename?: 'Company', companyId: string, name: string, companyCode?: number | null, nameKana?: string | null, prefectureId?: number | null, zipCode?: string | null, city?: string | null, street?: string | null, addressKana?: string | null, companyKind?: number | null, phoneNumber?: string | null } | null, contactRoom?: { __typename?: 'ContactRoom', id: string, publicTimelines: Array<{ __typename?: 'ContactRoomTimeline', id: string, title: string, description: string, publicMessages: Array<{ __typename?: 'ContactRoomTimelineMessage', id: string, message: string, sentAt: any, publicUser: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, companyId: string }, publicFiles?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null }> }> } | null, estimateRequest: { __typename?: 'EstimateRequest', id: string, title?: string | null, documentUniqueId?: string | null, requestTimeOn?: any | null, shippingLocation?: string | null, pickupDate?: any | null, cargoDeliveryDate?: any | null, requestFumigationCertificate?: boolean | null, requestCargoInspection?: boolean | null, incoterms?: Incoterms | null, files: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> } }> | null } };

export type NewEstimateRequest_QueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NewEstimateRequest_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', usdRate: number, company: { __typename?: 'ShipperCompany', shippers: Array<{ __typename?: 'Shipper', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> }, project: { __typename?: 'Project', id: string, title: string, createdAt: any, status: ProjectStatus, files: Array<{ __typename?: 'ProjectFile', id: string, action: ProjectAction, sentAt: any, projectId: string, contactRoomId?: string | null, contactRoomTimelineId?: string | null, file: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, presignedUrl: string }, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, company?: { __typename?: 'Company', companyId: string, name: string, companyCode?: number | null, nameKana?: string | null, prefectureId?: number | null, zipCode?: string | null, city?: string | null, street?: string | null, addressKana?: string | null, companyKind?: number | null, phoneNumber?: string | null } | null, participants: Array<{ __typename?: 'Shipper', id: string, lastName?: string | null, firstName?: string | null, email?: string | null }>, contactRoom?: { __typename?: 'ContactRoom', id: string, publicTimelines: Array<{ __typename?: 'ContactRoomTimeline', id: string, title: string, description: string, createdAt: any, publicFiles?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null, publicMessages: Array<{ __typename?: 'ContactRoomTimelineMessage', id: string, message: string, sentAt: any, publicUser: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, companyId: string }, publicFiles?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null }> }> } | null, publicProcesses: Array<{ __typename?: 'ProjectProcess', id: string, isDone: boolean, isPublish: boolean, limitedOn: any, task: { __typename?: 'ProjectProcessTask', id: string, nameJp: string, nameEn: string, taskPatterns: Array<{ __typename?: 'ProjectProcessTaskPattern', id: string, deductionDays: number, position: number }> } }>, publicWillboxEstimates: Array<{ __typename?: 'WillboxEstimate', id: string, isOrder: boolean, number: string, incoterms: Incoterms, latestStatus?: WillboxEstimateLatestStatus | null, usdRate: number, caution: string, paymentTerms: string, limitedOn?: any | null, isPublish: boolean, files: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }>, pol?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, pod?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, willboxEstimateFile?: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string } | null, orderFile?: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string } | null, transactionCertificateFile?: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string } | null, items: Array<{ __typename?: 'WillboxEstimateItem', id: string, description: string, count: number, unitFee: number, totalFee: number, parentItem: { __typename?: 'WillboxEstimateParentItem', id: number, name: string }, childItem: { __typename?: 'WillboxEstimateChildItem', id: number, name: string }, currencyFee: { __typename?: 'WillboxEstimateCurrentFee', id: number, name: string }, unit: { __typename?: 'WillboxEstimateUnit', id: number, name: string }, taxRate: { __typename?: 'WillboxEstimateTaxRate', id: number, name: string }, supplier: { __typename?: 'Supplier', id: string, companyName: string, companyNameKana: string, city: string, street: string, zipCode: string, companyPhone: string, prefecture: { __typename?: 'Prefecture', id: string, nameJp: string, nameEn: string, nameKana: string } } }> }>, estimateRequest: { __typename?: 'EstimateRequest', id: string, title?: string | null, description?: string | null, requestTimeOn?: any | null, shippingLocation?: string | null, pickupDate?: any | null, cargoDeliveryDate?: any | null, requestFumigationCertificate?: boolean | null, requestCargoInspection?: boolean | null, incoterms?: Incoterms | null, documentUniqueId?: string | null, files: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }>, pol?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, pod?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null } } } };

export type OnCreateEstimateRequest_MutationMutationVariables = Exact<{
  input: CreateEstimateRequestInput;
}>;


export type OnCreateEstimateRequest_MutationMutation = { __typename?: 'Mutation', createEstimateRequest: { __typename: 'CreateEstimateRequestPayload', clientMutationId?: string | null, estimateRequest: { __typename: 'EstimateRequest', id: string, title?: string | null, project: { __typename: 'Project', id: string } } } };

export type Home_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Home_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, mainPorts: Array<{ __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null }>, projects?: Array<{ __typename?: 'Project', id: string, title: string, createdAt: any, shipperFavorite: boolean, status: ProjectStatus, company?: { __typename?: 'Company', companyId: string, name: string, companyCode?: number | null, nameKana?: string | null, prefectureId?: number | null, zipCode?: string | null, city?: string | null, street?: string | null, addressKana?: string | null, companyKind?: number | null, phoneNumber?: string | null } | null, contactRoom?: { __typename?: 'ContactRoom', id: string, publicTimelines: Array<{ __typename?: 'ContactRoomTimeline', id: string, title: string, description: string, publicMessages: Array<{ __typename?: 'ContactRoomTimelineMessage', id: string, message: string, sentAt: any, publicUser: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, companyId: string }, publicFiles?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null }> }> } | null, estimateRequest: { __typename?: 'EstimateRequest', id: string, title?: string | null, documentUniqueId?: string | null, requestTimeOn?: any | null, shippingLocation?: string | null, pickupDate?: any | null, cargoDeliveryDate?: any | null, requestFumigationCertificate?: boolean | null, requestCargoInspection?: boolean | null, incoterms?: Incoterms | null, files: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> } }> | null } };

export type EditProjectModal_QueryQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type EditProjectModal_QueryQuery = { __typename?: 'Query', cxViewer: { __typename?: 'CxUser', project: { __typename?: 'Project', id: string, title: string, status: ProjectStatus, representative?: { __typename?: 'CxUser', user: { __typename?: 'User', id: string } } | null, estimateRequest: { __typename?: 'EstimateRequest', id: string, title?: string | null, description?: string | null, incoterms?: Incoterms | null, pol?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, pod?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null } } } };

export type ProjectDetail_QueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectDetail_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', usdRate: number, company: { __typename?: 'ShipperCompany', shippers: Array<{ __typename?: 'Shipper', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> }, project: { __typename?: 'Project', id: string, title: string, createdAt: any, shipperFavorite: boolean, status: ProjectStatus, files: Array<{ __typename?: 'ProjectFile', id: string, action: ProjectAction, sentAt: any, projectId: string, contactRoomId?: string | null, contactRoomTimelineId?: string | null, file: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, presignedUrl: string }, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, company?: { __typename?: 'Company', companyId: string, name: string, companyCode?: number | null, nameKana?: string | null, prefectureId?: number | null, zipCode?: string | null, city?: string | null, street?: string | null, addressKana?: string | null, companyKind?: number | null, phoneNumber?: string | null } | null, participants: Array<{ __typename?: 'Shipper', id: string, lastName?: string | null, firstName?: string | null, email?: string | null }>, contactRoom?: { __typename?: 'ContactRoom', id: string, publicTimelines: Array<{ __typename?: 'ContactRoomTimeline', id: string, title: string, description: string, createdAt: any, publicFiles?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null, publicMessages: Array<{ __typename?: 'ContactRoomTimelineMessage', id: string, message: string, sentAt: any, publicUser: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, companyId: string }, publicFiles?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null }> }> } | null, publicProcesses: Array<{ __typename?: 'ProjectProcess', id: string, isDone: boolean, isPublish: boolean, limitedOn: any, task: { __typename?: 'ProjectProcessTask', id: string, nameJp: string, nameEn: string, taskPatterns: Array<{ __typename?: 'ProjectProcessTaskPattern', id: string, deductionDays: number, position: number }> } }>, publicWillboxEstimates: Array<{ __typename?: 'WillboxEstimate', id: string, isOrder: boolean, number: string, incoterms: Incoterms, latestStatus?: WillboxEstimateLatestStatus | null, usdRate: number, totalAmount: number, caution: string, paymentTerms: string, limitedOn?: any | null, isPublish: boolean, files: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }>, pol?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, pod?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, willboxEstimateFile?: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string } | null, orderFile?: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string } | null, transactionCertificateFile?: { __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string } | null, items: Array<{ __typename?: 'WillboxEstimateItem', id: string, description: string, count: number, unitFee: number, totalFee: number, parentItem: { __typename?: 'WillboxEstimateParentItem', id: number, name: string }, childItem: { __typename?: 'WillboxEstimateChildItem', id: number, name: string }, currencyFee: { __typename?: 'WillboxEstimateCurrentFee', id: number, name: string }, unit: { __typename?: 'WillboxEstimateUnit', id: number, name: string }, taxRate: { __typename?: 'WillboxEstimateTaxRate', id: number, name: string }, supplier: { __typename?: 'Supplier', id: string, companyName: string, companyNameKana: string, city: string, street: string, zipCode: string, companyPhone: string, prefecture: { __typename?: 'Prefecture', id: string, nameJp: string, nameEn: string, nameKana: string } } }> }>, estimateRequest: { __typename?: 'EstimateRequest', id: string, title?: string | null, description?: string | null, requestTimeOn?: any | null, shippingLocation?: string | null, pickupDate?: any | null, cargoDeliveryDate?: any | null, requestFumigationCertificate?: boolean | null, requestCargoInspection?: boolean | null, incoterms?: Incoterms | null, documentUniqueId?: string | null, files: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }>, pol?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null, pod?: { __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null } | null } } } };

export type ProjectTable_QueryQueryVariables = Exact<{
  input: ShipperSearchProjectInput;
}>;


export type ProjectTable_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', projectsV2: { __typename?: 'ShipperProjectConnection', pageInfo: { __typename?: 'PageInfo', totalPages: number, totalCount: number, page: number, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, title: string, status: ProjectStatus, createdAt: any, shipperFavorite: boolean, estimateRequest: { __typename?: 'EstimateRequest', documentUniqueId?: string | null, requestTimeOn?: any | null } }> } } };

export type OnUpdate_MutationMutationVariables = Exact<{
  input: UpdateProjectTitleInput;
}>;


export type OnUpdate_MutationMutation = { __typename?: 'Mutation', updateProjectTitle: { __typename?: 'UpdateProjectTitlePayload', project: { __typename: 'Project', id: string, title: string } } };

export type OnUpdateProjectParticipants_MutationMutationVariables = Exact<{
  input: UpdateProjectParticipantsInput;
}>;


export type OnUpdateProjectParticipants_MutationMutation = { __typename?: 'Mutation', updateProjectParticipants: { __typename?: 'UpdateProjectParticipantsPayload', shippers: Array<{ __typename: 'Shipper', id: string }> } };

export type OnUpdateProjectFavorite_MutationMutationVariables = Exact<{
  input: UpdateShipperProjectFavoriteInput;
}>;


export type OnUpdateProjectFavorite_MutationMutation = { __typename?: 'Mutation', updateShipperProjectFavorite: { __typename?: 'UpdateShipperProjectFavoritePayload', clientMutationId?: string | null, project: { __typename: 'Project', id: string } } };

export type OnOrderWillboxEstimate_MutationMutationVariables = Exact<{
  input: OrderWillboxEstimateInput;
}>;


export type OnOrderWillboxEstimate_MutationMutation = { __typename?: 'Mutation', orderWillboxEstimate: { __typename?: 'OrderWillboxEstimatePayload', willboxEstimate: { __typename: 'WillboxEstimate', id: string } } };

export type TimelineDetail_QueryFragmentFragment = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', contactRoomTimeline: { __typename: 'ContactRoomTimeline', id: string, title: string, description: string, files?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null, messages: Array<{ __typename?: 'ContactRoomTimelineMessage', id: string, message: string, sentAt: any, user: { __typename?: 'User', id: string, publicLastName: string, publicFirstName: string, email: string, companyId: string }, files?: Array<{ __typename?: 'AwsS3File', awsS3FileId: string, originalName: string, objectUrl: string, presignedUrl: string }> | null }> } } } & { ' $fragmentName'?: 'TimelineDetail_QueryFragmentFragment' };

export type TimelineDetail_QueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimelineDetail_QueryQuery = (
  { __typename?: 'Query' }
  & { ' $fragmentRefs'?: { 'TimelineDetail_QueryFragmentFragment': TimelineDetail_QueryFragmentFragment } }
);

export type Timeline_QueryFragmentFragment = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', project: { __typename?: 'Project', id: string, title: string, company?: { __typename?: 'Company', name: string } | null, estimateRequest: { __typename?: 'EstimateRequest', documentUniqueId?: string | null }, contactRoom?: { __typename?: 'ContactRoom', id: string, timelines: Array<{ __typename?: 'ContactRoomTimeline', id: string, title: string, description: string, createdAt: any, user: { __typename?: 'User', publicLastName: string, publicFirstName: string } }> } | null } } } & { ' $fragmentName'?: 'Timeline_QueryFragmentFragment' };

export type Timeline_QueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type Timeline_QueryQuery = (
  { __typename?: 'Query' }
  & { ' $fragmentRefs'?: { 'Timeline_QueryFragmentFragment': Timeline_QueryFragmentFragment } }
);

export type OnCreateTimeline_MutationMutationVariables = Exact<{
  input: CreateContactRoomTimelineInput;
}>;


export type OnCreateTimeline_MutationMutation = { __typename?: 'Mutation', shipperCreateContactRoomTimeline: { __typename: 'CreateContactRoomTimelinePayload', clientMutationId?: string | null, timeline: { __typename: 'ContactRoomTimeline', id: string } } };

export type OnCreateTimelineMessage_MutationMutationVariables = Exact<{
  input: CreateContactRoomTimelineMessageInput;
}>;


export type OnCreateTimelineMessage_MutationMutation = { __typename?: 'Mutation', shipperCreateContactRoomTimelineMessage: { __typename: 'CreateContactRoomTimelineMessagePayload', message: { __typename: 'ContactRoomTimelineMessage', id: string, publicUser: { __typename: 'User', id: string, firstName: string, lastName: string }, publicTimeline?: { __typename: 'ContactRoomTimeline' } | null } } };

export type UsePorts_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePorts_QueryQuery = { __typename?: 'Query', shipperViewer: { __typename?: 'Shipper', mainPorts: Array<{ __typename?: 'MainPort', id: string, countryName: string, countryNameJa: string, countryCode?: string | null, mainPort?: string | null, mainPortJa?: string | null, portCode?: string | null }> } };

export const TimelineDetail_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineDetail_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactRoomTimeline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"files"},"name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"messages"},"name":{"kind":"Name","value":"publicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicLastName"}},{"kind":"Field","name":{"kind":"Name","value":"publicFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"files"},"name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimelineDetail_QueryFragmentFragment, unknown>;
export const Timeline_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeline_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"timelines"},"name":{"kind":"Name","value":"publicTimelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicLastName"}},{"kind":"Field","name":{"kind":"Name","value":"publicFirstName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Timeline_QueryFragmentFragment, unknown>;
export const Header_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Header_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Header_QueryQuery, Header_QueryQueryVariables>;
export const ContainerEc_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContainerEC_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchShipsOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchShipDateRangeQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchShipLocationQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchShipContainerSizeQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transhipCountType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchTransshipCountType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usdRate"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"transhipCountType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transhipCountType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"cutDay"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountJPY"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUSD"}},{"kind":"Field","name":{"kind":"Name","value":"detailItemsTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"unitName"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detailItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountJPY"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUSD"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyNameKana"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tranships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"port"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContainerEc_QueryQuery, ContainerEc_QueryQueryVariables>;
export const CreateContainerEcEstimateRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createContainerECEstimateRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContainerECEstimateRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContainerECEstimateRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateContainerEcEstimateRequestMutation, CreateContainerEcEstimateRequestMutationVariables>;
export const _NewEstimateRequest_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"_NewEstimateRequest_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mainPorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyCode"}},{"kind":"Field","name":{"kind":"Name","value":"nameKana"}},{"kind":"Field","name":{"kind":"Name","value":"prefectureId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"addressKana"}},{"kind":"Field","name":{"kind":"Name","value":"companyKind"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicTimelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"publicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"requestTimeOn"}},{"kind":"Field","name":{"kind":"Name","value":"shippingLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDate"}},{"kind":"Field","name":{"kind":"Name","value":"cargoDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"requestFumigationCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"requestCargoInspection"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<_NewEstimateRequest_QueryQuery, _NewEstimateRequest_QueryQueryVariables>;
export const NewEstimateRequest_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewEstimateRequest_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usdRate"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoomTimelineId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyCode"}},{"kind":"Field","name":{"kind":"Name","value":"nameKana"}},{"kind":"Field","name":{"kind":"Name","value":"prefectureId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"addressKana"}},{"kind":"Field","name":{"kind":"Name","value":"companyKind"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicTimelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicProcesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublish"}},{"kind":"Field","name":{"kind":"Name","value":"limitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameJp"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"taskPatterns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deductionDays"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicWillboxEstimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOrder"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"latestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"usdRate"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caution"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"}},{"kind":"Field","name":{"kind":"Name","value":"limitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isPublish"}},{"kind":"Field","alias":{"kind":"Name","value":"willboxEstimateFile"},"name":{"kind":"Name","value":"publicWillboxEstimateFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orderFile"},"name":{"kind":"Name","value":"publicOrderFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactionCertificateFile"},"name":{"kind":"Name","value":"publicTransactionCertificateFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"unitFee"}},{"kind":"Field","name":{"kind":"Name","value":"totalFee"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyNameKana"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameJp"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"nameKana"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"requestTimeOn"}},{"kind":"Field","name":{"kind":"Name","value":"shippingLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDate"}},{"kind":"Field","name":{"kind":"Name","value":"cargoDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"requestFumigationCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"requestCargoInspection"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewEstimateRequest_QueryQuery, NewEstimateRequest_QueryQueryVariables>;
export const OnCreateEstimateRequest_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnCreateEstimateRequest_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEstimateRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEstimateRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnCreateEstimateRequest_MutationMutation, OnCreateEstimateRequest_MutationMutationVariables>;
export const Home_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Home_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mainPorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shipperFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyCode"}},{"kind":"Field","name":{"kind":"Name","value":"nameKana"}},{"kind":"Field","name":{"kind":"Name","value":"prefectureId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"addressKana"}},{"kind":"Field","name":{"kind":"Name","value":"companyKind"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicTimelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"publicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"requestTimeOn"}},{"kind":"Field","name":{"kind":"Name","value":"shippingLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDate"}},{"kind":"Field","name":{"kind":"Name","value":"cargoDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"requestFumigationCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"requestCargoInspection"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Home_QueryQuery, Home_QueryQueryVariables>;
export const EditProjectModal_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditProjectModal_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cxViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"representative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"pol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditProjectModal_QueryQuery, EditProjectModal_QueryQueryVariables>;
export const ProjectDetail_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectDetail_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usdRate"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shipperFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoomTimelineId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyCode"}},{"kind":"Field","name":{"kind":"Name","value":"nameKana"}},{"kind":"Field","name":{"kind":"Name","value":"prefectureId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"addressKana"}},{"kind":"Field","name":{"kind":"Name","value":"companyKind"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicTimelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicProcesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublish"}},{"kind":"Field","name":{"kind":"Name","value":"limitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameJp"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"taskPatterns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deductionDays"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicWillboxEstimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOrder"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"latestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"usdRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caution"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"}},{"kind":"Field","name":{"kind":"Name","value":"limitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isPublish"}},{"kind":"Field","alias":{"kind":"Name","value":"willboxEstimateFile"},"name":{"kind":"Name","value":"publicWillboxEstimateFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orderFile"},"name":{"kind":"Name","value":"publicOrderFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactionCertificateFile"},"name":{"kind":"Name","value":"publicTransactionCertificateFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"unitFee"}},{"kind":"Field","name":{"kind":"Name","value":"totalFee"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyNameKana"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameJp"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"nameKana"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"requestTimeOn"}},{"kind":"Field","name":{"kind":"Name","value":"shippingLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDate"}},{"kind":"Field","name":{"kind":"Name","value":"cargoDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"requestFumigationCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"requestCargoInspection"}},{"kind":"Field","name":{"kind":"Name","value":"incoterms"}},{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectDetail_QueryQuery, ProjectDetail_QueryQueryVariables>;
export const ProjectTable_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTable_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShipperSearchProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shipperFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"requestTimeOn"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTable_QueryQuery, ProjectTable_QueryQueryVariables>;
export const OnUpdate_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnUpdate_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectTitleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<OnUpdate_MutationMutation, OnUpdate_MutationMutationVariables>;
export const OnUpdateProjectParticipants_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnUpdateProjectParticipants_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectParticipantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OnUpdateProjectParticipants_MutationMutation, OnUpdateProjectParticipants_MutationMutationVariables>;
export const OnUpdateProjectFavorite_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnUpdateProjectFavorite_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShipperProjectFavoriteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShipperProjectFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OnUpdateProjectFavorite_MutationMutation, OnUpdateProjectFavorite_MutationMutationVariables>;
export const OnOrderWillboxEstimate_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnOrderWillboxEstimate_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWillboxEstimateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderWillboxEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"willboxEstimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OnOrderWillboxEstimate_MutationMutation, OnOrderWillboxEstimate_MutationMutationVariables>;
export const TimelineDetail_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TimelineDetail_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineDetail_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineDetail_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactRoomTimeline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"files"},"name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"messages"},"name":{"kind":"Name","value":"publicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicLastName"}},{"kind":"Field","name":{"kind":"Name","value":"publicFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"files"},"name":{"kind":"Name","value":"publicFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awsS3FileId"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}},{"kind":"Field","name":{"kind":"Name","value":"objectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimelineDetail_QueryQuery, TimelineDetail_QueryQueryVariables>;
export const Timeline_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Timeline_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeline_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeline_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"timelines"},"name":{"kind":"Name","value":"publicTimelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicLastName"}},{"kind":"Field","name":{"kind":"Name","value":"publicFirstName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Timeline_QueryQuery, Timeline_QueryQueryVariables>;
export const OnCreateTimeline_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnCreateTimeline_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContactRoomTimelineInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperCreateContactRoomTimeline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OnCreateTimeline_MutationMutation, OnCreateTimeline_MutationMutationVariables>;
export const OnCreateTimelineMessage_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnCreateTimelineMessage_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContactRoomTimelineMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperCreateContactRoomTimelineMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicTimeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnCreateTimelineMessage_MutationMutation, OnCreateTimelineMessage_MutationMutationVariables>;
export const UsePorts_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsePorts_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipperViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainPorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryNameJa"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainPort"}},{"kind":"Field","name":{"kind":"Name","value":"mainPortJa"}},{"kind":"Field","name":{"kind":"Name","value":"portCode"}}]}}]}}]}}]} as unknown as DocumentNode<UsePorts_QueryQuery, UsePorts_QueryQueryVariables>;